import React from 'react';
import { Popper, PopperProps } from '@mui/material';
import { RevealOnMount } from './MotionGrow';

// Autocomplete lists open with the shared dropdown reveal (opening only; see RevealOnMount).
const MotionAutocompletePopper = React.forwardRef<HTMLDivElement, PopperProps>(
  function MotionAutocompletePopper({ children, ...props }, ref) {
    return (
      <Popper ref={ref} {...props}>
        {React.isValidElement(children) ? <RevealOnMount>{children as React.ReactElement}</RevealOnMount> : children}
      </Popper>
    );
  },
);

export default MotionAutocompletePopper;
